__turbopack_context__.v({
  "plantTrees": "styledComponents-module__QgA2nW__plantTrees",
  "shimmerBlue": "styledComponents-module__QgA2nW__shimmerBlue",
  "subscriptionDisclaimerDiv": "styledComponents-module__QgA2nW__subscriptionDisclaimerDiv",
});
